<template>
	<SignUpPageBase :content="this">
		<h4 class="font_lg font_bold margin_title_bottom">{{ $t("signUp.registrationAuthority.title") }}</h4>
		<form class="flex flex_center flex_column w_100">
			<md-field :class="[{ 'md-error': errors.has('companyVatNumber')}]">
				<label>{{ $t("common.vatId") }}</label>
				<md-input
					v-model="form.companyVatNumber"
					v-validate="modelValidations.companyVatNumber"
					data-vv-name="companyVatNumber"
					autocomplete="organization-vat-number"
					required
				></md-input>
				<span v-if="errors.has('companyVatNumber')" class="validation-error">{{ errors.first("companyVatNumber") }}</span>
			</md-field>
			<RegisterSelect
				:labelText="$t('common.registrationAuthority')"
				v-model="form.companyRegisterCourtId"
				@input="registerChanged"
				@ready="registerChanged"
				:country="signUpData.companyCountry"
				v-validate="modelValidations.companyRegisterCourtId"
				data-vv-name="companyRegisterCourtId"
				:error="errors.first('companyRegisterCourtId')"
				required
				ref="registerSelect"
				:blacklistFunction="(item) => item.enabled === false"
			></RegisterSelect>
			<md-field :class="[{ 'md-error': errors.has('companyRegistrationNumber')}]" v-if="requiresNumber">
				<label>{{ $t("common.registrationNumber") }}</label>
				<md-input
					:key="'companyRegistrationNumber' + modelValidations.companyRegistrationNumber.required"
					v-model="form.companyRegistrationNumber"
					v-validate="modelValidations.companyRegistrationNumber"
					data-vv-name="companyRegistrationNumber"
					autocomplete="organization-register-number"
					:required="modelValidations.companyRegistrationNumber.required"
				></md-input>
				<span v-if="errors.has('companyRegistrationNumber')" class="validation-error">{{ errors.first("companyRegistrationNumber") }}</span>
			</md-field>
			<CommonFileUpload v-if="requiresDocument"
				class="w_100"
				:key="'companyRegistrationFileId' + modelValidations.companyRegistrationDocument.required"
				v-model="form.companyRegistrationDocument"
				:uploadFunction="uploadCompanyRegistrationFile"
				:placeholderKey="getCompanyRegistrationFileNameKey()"
				v-validate="modelValidations.companyRegistrationDocument"
				data-vv-name="companyRegistrationDocument"
				:error="errors.first('companyRegistrationDocument')"
				:required="modelValidations.companyRegistrationDocument.required"
			></CommonFileUpload>
		</form>
	</SignUpPageBase>
</template>

<script>

import SignUpPageBase from "@/views/register/SignUpPageBase";
import RegisterSelect from "@/components/templates/select/RegisterSelect";
import {mapGetters} from "vuex";
import CommonFileUpload from "@/components/templates/common/CommonFileUpload";
import {registrationApi} from "@/common/api/registrationApi";

export default {
	components: {
		RegisterSelect,
		SignUpPageBase,
		CommonFileUpload
	},
	data() {
		return {
			form: {
				companyVatNumber: "",
				companyRegisterCourtId: null,
				companyRegistrationNumber: "",
				companyRegistrationDocument: null
			},
			modelValidations: {
				companyVatNumber: {
					required: true,
				},
				companyRegisterCourtId: {
					required: true,
				},
				companyRegistrationNumber: {
					required: false,
				},
				companyRegistrationDocument: {
					required: false,
					required_property: {
						name: "fileId"
					}
				},
			},

		};
	},
	created() {
		this.$mergeOnlyExistingProps(this.form, this.signUpData, true);

		this.form.companyRegistrationDocument = {
			fileId: this.signUpData.companyRegistrationFileId,
			fileName: this.signUpData.companyRegistrationFileName
		};
	},
	computed: {
		...mapGetters({
			signUpData: "local/signUpData"
		}),
		requiresDocument() {
			return this.modelValidations.companyRegistrationDocument.required;
		},
		requiresNumber() {
			return this.modelValidations.companyRegistrationNumber.required;
		}
	},
	methods: {
		getCompanyRegistrationFileNameKey() {
			return this.$refs.registerSelect ? this.$refs.registerSelect.getRequiredDocumentNameKeyForSelected() : "";
		},
		registerChanged() {
			this.modelValidations.companyRegistrationDocument.required = this.$refs.registerSelect.doesSelectedRequireDocument();
			this.modelValidations.companyRegistrationNumber.required = this.$refs.registerSelect.doesSelectedRequireRegistrationNumber();

			if (!this.requiresDocument) {
				this.form.companyRegistrationDocument = { fileId: "", fileName: "" };
			}

			if (!this.requiresNumber) {
				this.form.companyRegistrationNumber = "";
			}
		},
		validateData() {
			return registrationApi.checkLegalData({
				...this.signUpData,
				...this.getFlattenedFormData()
			});
		},
		beforeNext() {
			this.form = this.getFlattenedFormData();
		},
		uploadCompanyRegistrationFile(params) {
			return registrationApi.uploadRegistrationDocument(params);
		},
		getFlattenedFormData() {
			let flattenedForm = {
				...this.form,
				companyRegistrationFileId: this.form.companyRegistrationDocument.fileId,
				companyRegistrationFileName: this.form.companyRegistrationDocument.fileName,
			};

			delete flattenedForm.companyRegistrationDocument;

			return flattenedForm;
		}
	},
};
</script>